/* Base API URL */

const VERSION = '/api/v1';
/* AUTH */
const AUTH = {
  LOGIN: `${VERSION}/auth/login`,
  FORGOT_PASSWORD: `${VERSION}/auth/password/email`,
  RESET_PASSWORD: `${VERSION}/auth/password/reset`,
  GET_RESET_PASSWORD: `${VERSION}/auth/password/validate/reset`,
  LOGOUT: `${VERSION}/auth/logout`,
  SET_PASSWORD: `${VERSION}/auth/password/set`,
  GET_SET_PASSWORD: `${VERSION}/auth/password/validate/set`,
  RESEND_ACTIVATION: `${VERSION}/auth/resend-set-password`,
  UPDATE_ACCESSTOKEN: `${VERSION}/auth/validate-refresh-token`
  // VERIFY_EMAIL: VERSION + "/api/v1/auth/verify-email-change",
};

const DEPARTMENT = {
  LIST: `${VERSION}/department`,
  ADD: `${VERSION}/department`,
  EDIT: `${VERSION}/department`,
  UPDATE: `${VERSION}/department`,
  DELETE: `${VERSION}/department`,
  ACTIVE: `${VERSION}/active-department`
};

const UOM = {
  LIST: `${VERSION}/uom`,
  ADD: `${VERSION}/uom`,
  EDIT: `${VERSION}/uom`,
  UPDATE: `${VERSION}/uom`,
  DELETE: `${VERSION}/uom`,
  ACTIVE: `${VERSION}/active-uom`
};

const CURRENCY = {
  LIST: `${VERSION}/currency`,
  LIST_ALL_CURRENCY: `${VERSION}/master/currency`,
  ADD: `${VERSION}/currency`,
  EDIT: `${VERSION}/currency`,
  UPDATE: `${VERSION}/currency`,
  DELETE: `${VERSION}/currency`,
  ACTIVE: `${VERSION}/active-currency`
};

const CLIENT = {
  LIST: `${VERSION}/client`,
  ADD: `${VERSION}/client`,
  EDIT: `${VERSION}/client`,
  UPDATE: `${VERSION}/client`,
  DELETE: `${VERSION}/client`,
  BASED_ON_COMPANY: `${VERSION}/company-client`,
  ACTIVE: `${VERSION}/active-client`,
  IMPORT: `${VERSION}/client/import`,
  IMPORT_TEMPLATE: `${VERSION}/client/import-template`
};

const GLOBAL = {
  GET_CLIENT_STATUS: `${VERSION}/status`,
  GET_COUNTRY: `${VERSION}`,
  GET_STATE: `${VERSION}`,
  GET_ADDRESS: `${VERSION}/address`,
  GET_STATUS: `${VERSION}/status`,
  GET_ALL_NOTIFICATIONS: `${VERSION}/notifications`,
  READ_NOTIFICATION: `${VERSION}/notifications`,
  READ_ALL_NOTIFICATIONS: `${VERSION}/notifications/read-all`
};

const ROLES = {
  LIST: `${VERSION}/roles`,
  ADD: `${VERSION}/roles`,
  EDIT: `${VERSION}/roles`,
  UPDATE: `${VERSION}/roles`,
  DELETE: `${VERSION}/roles`,
  ACTIVE: `${VERSION}/active-roles`
};

const USER = {
  LIST: `${VERSION}/user`,
  ADD: `${VERSION}/user`,
  EDIT: `${VERSION}/user`,
  UPDATE: `${VERSION}/user`,
  DELETE: `${VERSION}/user`,
  ACTIVE: `${VERSION}/active-users`
};

const PERMISSIONS = {
  GET_ALL_LIST: `${VERSION}/permissions`,
  GET_ITEM: `${VERSION}/permissions`,
  ASSIGN: `${VERSION}/assign`,
  CURRENT_USER: `${VERSION}/permissions/current-user`
};

const AUDIT_TRAIL = {
  LIST: `${VERSION}/audit`,
  GET_ITEM: `${VERSION}/audit`,
  GET_MODULE: `${VERSION}/audit/get/module`,
  GET_USER: `${VERSION}/audit/get/user`
};

const DASHBOARD = {
  GET_ALL: `${VERSION}/dashboard`,
  FILTER_OPTIONS: `${VERSION}/dashboard/filters`
};

const COMPANY = {
  LIST: `${VERSION}/company`,
  ADD: `${VERSION}/company`,
  EDIT: `${VERSION}/company`,
  UPDATE: `${VERSION}/company`,
  DELETE: `${VERSION}/company`,
  ACTIVE: `${VERSION}/active-company`
};

const PAYMENT = {
  LIST: `${VERSION}/invoice`,
  ADD: `${VERSION}/invoice`,
  EDIT: `${VERSION}/invoice`,
  UPDATE: `${VERSION}/invoice`,
  DELETE: `${VERSION}/invoice`,
  GET_LIST_FILTER: `${VERSION}/invoice-filter`,
  GET_INVOICE_NUMBER: `${VERSION}/invoice-number`,
  GET_PAYMENT_VIA: `${VERSION}/pay-method`,
  GET_PAYMENT_TYPE: `${VERSION}/pay-request-type`,
  UPDATE_PREVIEW: `${VERSION}/invoice`,
  RESEND: `${VERSION}/resent-invoice`,
  REMINDER: `${VERSION}/remind-invoice`,
  COPY: `${VERSION}/copy-invoice`,
  GET_ALL_TRANSACTION: `${VERSION}/transaction`,
  GET_TRANSACTION_ITEM: `${VERSION}/transaction`,
  GET_TRANSACTION_STATUS: `${VERSION}/transaction-filter`,
  PREVIEW_MAIL: `${VERSION}/preview-mail`,
  PREVIEW_MAIL_SEND: `${VERSION}/preview-mail-send`,
  // Payment API - 3rd Parties
  GET_PAYMENT_DETAILS: `${VERSION}/payment`,
  GENERATE_PAYPAL: `${VERSION}/payment-gen`,
  AUTHORIZENET: `${VERSION}/payment`,
  STRIPE: `${VERSION}/payment`,
  PAYPAL_STATUS: `${VERSION}/payment`,
  GENERATE_VEEM: `${VERSION}/payment-gen`,
  // Payment API - 3rd Parties
  GET_PENDING_ITEMS: `${VERSION}/pending-invoice`,
  MANUAL_LIST: `${VERSION}/manual-payment`,
  MANUAL_ADD: `${VERSION}/manual-payment`,
  WRITEOFF_ADD: `${VERSION}/write-off`,
  MANUAL_EDIT: `${VERSION}/manual-payment-get`,
  MANUAL_UPDATE: `${VERSION}/manual-payment`,
  MANUAL_FILTER: `${VERSION}/manual-payment-filter`,
  DELETE_TIMESHEET: `${VERSION}/invoice-remove-sheet`,
  CLOVER: `${VERSION}/clover/charge`,
  STATUS: `${VERSION}/payment-status`,
  SCHEDULE_CANCEL: `${VERSION}/invoice-schedule-cancel`
};

const SETTING = {
  GET_MAIL_VARIABLE: `${VERSION}/settings/mail-temp-variable`,
  GET_PAYPAL: `${VERSION}/settings/pay-pal`,
  GET_STRIPE: `${VERSION}/settings/stripe`,
  GET_VEEM: `${VERSION}/settings/veem`,
  GET_BANKOFAMERICA: `${VERSION}/settings/bank-of-america`,
  GET_CLOVER: `${VERSION}/settings/clover`,
  GET_AUTHORIZENET: `${VERSION}/settings/authorize`,
  UPDATE_PAYPAL: `${VERSION}/settings/pay-pal`,
  UPDATE_STRIPE: `${VERSION}/settings/stripe `,
  UPDATE_AUTHORIZENET: `${VERSION}/settings/authorize`,
  UPDATE_VEEM: `${VERSION}/settings/veem `,
  UPDATE_BANKOFAMERICA: `${VERSION}/settings/bank-of-america`,
  UPDATE_CLOVER: `${VERSION}/settings/clover`,
  GENERAL_ITEM: `${VERSION}/settings/general`,
  UPDATE_GENERAL_ITEM: `${VERSION}/settings/general`,
  GET_PROFILE: `${VERSION}/settings/profile`,
  UPDATE_PROFILE: `${VERSION}/settings/profile`,
  VERIFY_MAIL: `${VERSION}/verify-email`,
  UPDATE_PASSWORD: `${VERSION}/settings/change-password`,
  BANK_LIST: `${VERSION}/beneficiary`,
  ADD_BANK: `${VERSION}/beneficiary`,
  GET_BANK_ITEM: `${VERSION}/beneficiary`,
  UPDATE_BANK: `${VERSION}/beneficiary`,
  DELETE_BANK: `${VERSION}/beneficiary`,
  OFFICE_LIST: `${VERSION}/office-address`,
  ADD_OFFICE: `${VERSION}/office-address`,
  GET_OFFICE_ITEM: `${VERSION}/office-address`,
  UPDATE_OFFICE: `${VERSION}/office-address`,
  DELETE_OFFICE: `${VERSION}/office-address`,
  SIGNATURE_LIST: `${VERSION}/signature`,
  ADD_SIGNATURE: `${VERSION}/signature`,
  GET_SIGNATURE_ITEM: `${VERSION}/signature`,
  UPDATE_SIGNATURE: `${VERSION}/signature`,
  DELETE_SIGNATURE: `${VERSION}/signature`
};

const REPORT = {
  SUMMARY_LIST: `${VERSION}/reports/summary`,
  SUMMARY_FILTER: `${VERSION}/reports/summary-filters`,
  AGEING_LIST: `${VERSION}/reports/ageing`,
  AGEING_FILTER: `${VERSION}/reports/ageing-filters`,
  FILTER: `${VERSION}/reports/filters`,
  CLIENT_BASED: `${VERSION}/reports/client-based`,
  DEPARTMENT_BASED: `${VERSION}/reports/department-based`
};

export {
  AUTH,
  DEPARTMENT,
  GLOBAL,
  UOM,
  CURRENCY,
  CLIENT,
  ROLES,
  PERMISSIONS,
  USER,
  AUDIT_TRAIL,
  COMPANY,
  PAYMENT,
  SETTING,
  DASHBOARD,
  REPORT
};
